// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/cabling.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { PortConfigType, portConfigTypeFromJSON, portConfigTypeToJSON } from "./fabric";
import {
  CablingConnection,
  FabricDesign,
  ServerGroupConnectivityRule,
  SwitchGroupConnectivityRule,
} from "./fabric_design";

export const protobufPackage = "models";

export enum CablingPlanStatus {
  CABLING_PLAN_STATUS_INVALID = 0,
  CABLING_PLAN_STATUS_SUCCESS = 1,
  CABLING_PLAN_STATUS_FAILURE_PORTS_UNAVAILABLE = 2,
  UNRECOGNIZED = -1,
}

export function cablingPlanStatusFromJSON(object: any): CablingPlanStatus {
  switch (object) {
    case 0:
    case "CABLING_PLAN_STATUS_INVALID":
      return CablingPlanStatus.CABLING_PLAN_STATUS_INVALID;
    case 1:
    case "CABLING_PLAN_STATUS_SUCCESS":
      return CablingPlanStatus.CABLING_PLAN_STATUS_SUCCESS;
    case 2:
    case "CABLING_PLAN_STATUS_FAILURE_PORTS_UNAVAILABLE":
      return CablingPlanStatus.CABLING_PLAN_STATUS_FAILURE_PORTS_UNAVAILABLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CablingPlanStatus.UNRECOGNIZED;
  }
}

export function cablingPlanStatusToJSON(object: CablingPlanStatus): string {
  switch (object) {
    case CablingPlanStatus.CABLING_PLAN_STATUS_INVALID:
      return "CABLING_PLAN_STATUS_INVALID";
    case CablingPlanStatus.CABLING_PLAN_STATUS_SUCCESS:
      return "CABLING_PLAN_STATUS_SUCCESS";
    case CablingPlanStatus.CABLING_PLAN_STATUS_FAILURE_PORTS_UNAVAILABLE:
      return "CABLING_PLAN_STATUS_FAILURE_PORTS_UNAVAILABLE";
    case CablingPlanStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PortData {
  portName: string;
  portConfigType: PortConfigType;
}

export interface NodePortGroup {
  pluggable: string;
  speed: string;
  portData: PortData[];
}

export interface NodeBreakoutGroup {
  /** Breakout mode. E.g. 2x200G(2) */
  mode: string;
  /** User-defined cable model name (PID). */
  pluggable: string;
  /** The names of base network ports. */
  basePorts: string[];
}

export interface DesignNodeData {
  nodeId: string;
  deviceId: string;
  serialNumber: string;
  nodePortGroup: NodePortGroup[];
  nodeBreakoutGroup: NodeBreakoutGroup[];
  trayId: number;
  parentId: string;
}

export interface DesignBasedCablingRequest {
  /** @deprecated */
  orgId: string;
  fabricId: string;
  /** The fabric design to evaluate */
  design: FabricDesign | undefined;
  dryRun: boolean;
  failFast: boolean;
  includeCablingPlan: boolean;
  /**
   * This includes information about the bound device id and serial number of nodes in the blueprint
   * This data helps bilge pull observed state from devices that have not yet been committed, but
   * are a part of the candidate (since Bilge only has access to committed data).
   */
  nodeData: DesignNodeData[];
  includeExceptions: boolean;
  candidate: string;
  excludeObservedStateDataInResponse: boolean;
}

export interface RuleExecutionException {
  /** If the rule is a swgrp <-> swgrp rule */
  swGroupRule:
    | SwitchGroupConnectivityRule
    | undefined;
  /** If the rule is a svrgrp <-> svrgrp rule */
  svrGroupRule:
    | ServerGroupConnectivityRule
    | undefined;
  /**
   * When the connection is a group connection, the following
   * properties specify which node/port <-> node/port connection
   * failed because of a port deficit.
   */
  portDeficit: number;
  node1Name: string;
  node1Id: string;
  node2Name: string;
  node2Id: string;
  node2RailName: string;
  node2RailId: string;
}

export interface DesignBasedCablingResponse {
  connections: CablingConnection[];
  execStatus: CablingPlanStatus;
  exceptions: RuleExecutionException[];
  observedConnections: CablingConnection[];
}

export interface GetObservedStateRequest {
  fabricId: string;
  nodeData: DesignNodeData[];
  design: FabricDesign | undefined;
}

export interface GetObservedStateResponse {
  observedState: CablingConnection[];
}

function createBasePortData(): PortData {
  return { portName: "", portConfigType: 0 };
}

export const PortData: MessageFns<PortData> = {
  encode(message: PortData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.portName !== "") {
      writer.uint32(10).string(message.portName);
    }
    if (message.portConfigType !== 0) {
      writer.uint32(16).int32(message.portConfigType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.portConfigType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortData {
    return {
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      portConfigType: isSet(object.portConfigType) ? portConfigTypeFromJSON(object.portConfigType) : 0,
    };
  },

  toJSON(message: PortData): unknown {
    const obj: any = {};
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.portConfigType !== 0) {
      obj.portConfigType = portConfigTypeToJSON(message.portConfigType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortData>, I>>(base?: I): PortData {
    return PortData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortData>, I>>(object: I): PortData {
    const message = createBasePortData();
    message.portName = object.portName ?? "";
    message.portConfigType = object.portConfigType ?? 0;
    return message;
  },
};

function createBaseNodePortGroup(): NodePortGroup {
  return { pluggable: "", speed: "", portData: [] };
}

export const NodePortGroup: MessageFns<NodePortGroup> = {
  encode(message: NodePortGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pluggable !== "") {
      writer.uint32(10).string(message.pluggable);
    }
    if (message.speed !== "") {
      writer.uint32(18).string(message.speed);
    }
    for (const v of message.portData) {
      PortData.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodePortGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodePortGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pluggable = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.speed = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portData.push(PortData.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NodePortGroup {
    return {
      pluggable: isSet(object.pluggable) ? globalThis.String(object.pluggable) : "",
      speed: isSet(object.speed) ? globalThis.String(object.speed) : "",
      portData: globalThis.Array.isArray(object?.portData) ? object.portData.map((e: any) => PortData.fromJSON(e)) : [],
    };
  },

  toJSON(message: NodePortGroup): unknown {
    const obj: any = {};
    if (message.pluggable !== "") {
      obj.pluggable = message.pluggable;
    }
    if (message.speed !== "") {
      obj.speed = message.speed;
    }
    if (message.portData?.length) {
      obj.portData = message.portData.map((e) => PortData.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodePortGroup>, I>>(base?: I): NodePortGroup {
    return NodePortGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodePortGroup>, I>>(object: I): NodePortGroup {
    const message = createBaseNodePortGroup();
    message.pluggable = object.pluggable ?? "";
    message.speed = object.speed ?? "";
    message.portData = object.portData?.map((e) => PortData.fromPartial(e)) || [];
    return message;
  },
};

function createBaseNodeBreakoutGroup(): NodeBreakoutGroup {
  return { mode: "", pluggable: "", basePorts: [] };
}

export const NodeBreakoutGroup: MessageFns<NodeBreakoutGroup> = {
  encode(message: NodeBreakoutGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== "") {
      writer.uint32(10).string(message.mode);
    }
    if (message.pluggable !== "") {
      writer.uint32(18).string(message.pluggable);
    }
    for (const v of message.basePorts) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeBreakoutGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodeBreakoutGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mode = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pluggable = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.basePorts.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NodeBreakoutGroup {
    return {
      mode: isSet(object.mode) ? globalThis.String(object.mode) : "",
      pluggable: isSet(object.pluggable) ? globalThis.String(object.pluggable) : "",
      basePorts: globalThis.Array.isArray(object?.basePorts)
        ? object.basePorts.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: NodeBreakoutGroup): unknown {
    const obj: any = {};
    if (message.mode !== "") {
      obj.mode = message.mode;
    }
    if (message.pluggable !== "") {
      obj.pluggable = message.pluggable;
    }
    if (message.basePorts?.length) {
      obj.basePorts = message.basePorts;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeBreakoutGroup>, I>>(base?: I): NodeBreakoutGroup {
    return NodeBreakoutGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeBreakoutGroup>, I>>(object: I): NodeBreakoutGroup {
    const message = createBaseNodeBreakoutGroup();
    message.mode = object.mode ?? "";
    message.pluggable = object.pluggable ?? "";
    message.basePorts = object.basePorts?.map((e) => e) || [];
    return message;
  },
};

function createBaseDesignNodeData(): DesignNodeData {
  return {
    nodeId: "",
    deviceId: "",
    serialNumber: "",
    nodePortGroup: [],
    nodeBreakoutGroup: [],
    trayId: 0,
    parentId: "",
  };
}

export const DesignNodeData: MessageFns<DesignNodeData> = {
  encode(message: DesignNodeData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeId !== "") {
      writer.uint32(10).string(message.nodeId);
    }
    if (message.deviceId !== "") {
      writer.uint32(18).string(message.deviceId);
    }
    if (message.serialNumber !== "") {
      writer.uint32(26).string(message.serialNumber);
    }
    for (const v of message.nodePortGroup) {
      NodePortGroup.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.nodeBreakoutGroup) {
      NodeBreakoutGroup.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.trayId !== 0) {
      writer.uint32(48).uint32(message.trayId);
    }
    if (message.parentId !== "") {
      writer.uint32(58).string(message.parentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DesignNodeData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDesignNodeData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.nodePortGroup.push(NodePortGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.nodeBreakoutGroup.push(NodeBreakoutGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.trayId = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DesignNodeData {
    return {
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      nodePortGroup: globalThis.Array.isArray(object?.nodePortGroup)
        ? object.nodePortGroup.map((e: any) => NodePortGroup.fromJSON(e))
        : [],
      nodeBreakoutGroup: globalThis.Array.isArray(object?.nodeBreakoutGroup)
        ? object.nodeBreakoutGroup.map((e: any) => NodeBreakoutGroup.fromJSON(e))
        : [],
      trayId: isSet(object.trayId) ? globalThis.Number(object.trayId) : 0,
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : "",
    };
  },

  toJSON(message: DesignNodeData): unknown {
    const obj: any = {};
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.nodePortGroup?.length) {
      obj.nodePortGroup = message.nodePortGroup.map((e) => NodePortGroup.toJSON(e));
    }
    if (message.nodeBreakoutGroup?.length) {
      obj.nodeBreakoutGroup = message.nodeBreakoutGroup.map((e) => NodeBreakoutGroup.toJSON(e));
    }
    if (message.trayId !== 0) {
      obj.trayId = Math.round(message.trayId);
    }
    if (message.parentId !== "") {
      obj.parentId = message.parentId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DesignNodeData>, I>>(base?: I): DesignNodeData {
    return DesignNodeData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DesignNodeData>, I>>(object: I): DesignNodeData {
    const message = createBaseDesignNodeData();
    message.nodeId = object.nodeId ?? "";
    message.deviceId = object.deviceId ?? "";
    message.serialNumber = object.serialNumber ?? "";
    message.nodePortGroup = object.nodePortGroup?.map((e) => NodePortGroup.fromPartial(e)) || [];
    message.nodeBreakoutGroup = object.nodeBreakoutGroup?.map((e) => NodeBreakoutGroup.fromPartial(e)) || [];
    message.trayId = object.trayId ?? 0;
    message.parentId = object.parentId ?? "";
    return message;
  },
};

function createBaseDesignBasedCablingRequest(): DesignBasedCablingRequest {
  return {
    orgId: "",
    fabricId: "",
    design: undefined,
    dryRun: false,
    failFast: false,
    includeCablingPlan: false,
    nodeData: [],
    includeExceptions: false,
    candidate: "",
    excludeObservedStateDataInResponse: false,
  };
}

export const DesignBasedCablingRequest: MessageFns<DesignBasedCablingRequest> = {
  encode(message: DesignBasedCablingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.design !== undefined) {
      FabricDesign.encode(message.design, writer.uint32(26).fork()).join();
    }
    if (message.dryRun !== false) {
      writer.uint32(32).bool(message.dryRun);
    }
    if (message.failFast !== false) {
      writer.uint32(40).bool(message.failFast);
    }
    if (message.includeCablingPlan !== false) {
      writer.uint32(48).bool(message.includeCablingPlan);
    }
    for (const v of message.nodeData) {
      DesignNodeData.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.includeExceptions !== false) {
      writer.uint32(64).bool(message.includeExceptions);
    }
    if (message.candidate !== "") {
      writer.uint32(74).string(message.candidate);
    }
    if (message.excludeObservedStateDataInResponse !== false) {
      writer.uint32(80).bool(message.excludeObservedStateDataInResponse);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DesignBasedCablingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDesignBasedCablingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.design = FabricDesign.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.failFast = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.includeCablingPlan = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.nodeData.push(DesignNodeData.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.includeExceptions = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.excludeObservedStateDataInResponse = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DesignBasedCablingRequest {
    return {
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      design: isSet(object.design) ? FabricDesign.fromJSON(object.design) : undefined,
      dryRun: isSet(object.dryRun) ? globalThis.Boolean(object.dryRun) : false,
      failFast: isSet(object.failFast) ? globalThis.Boolean(object.failFast) : false,
      includeCablingPlan: isSet(object.includeCablingPlan) ? globalThis.Boolean(object.includeCablingPlan) : false,
      nodeData: globalThis.Array.isArray(object?.nodeData)
        ? object.nodeData.map((e: any) => DesignNodeData.fromJSON(e))
        : [],
      includeExceptions: isSet(object.includeExceptions) ? globalThis.Boolean(object.includeExceptions) : false,
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      excludeObservedStateDataInResponse: isSet(object.excludeObservedStateDataInResponse)
        ? globalThis.Boolean(object.excludeObservedStateDataInResponse)
        : false,
    };
  },

  toJSON(message: DesignBasedCablingRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.design !== undefined) {
      obj.design = FabricDesign.toJSON(message.design);
    }
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    if (message.failFast !== false) {
      obj.failFast = message.failFast;
    }
    if (message.includeCablingPlan !== false) {
      obj.includeCablingPlan = message.includeCablingPlan;
    }
    if (message.nodeData?.length) {
      obj.nodeData = message.nodeData.map((e) => DesignNodeData.toJSON(e));
    }
    if (message.includeExceptions !== false) {
      obj.includeExceptions = message.includeExceptions;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.excludeObservedStateDataInResponse !== false) {
      obj.excludeObservedStateDataInResponse = message.excludeObservedStateDataInResponse;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DesignBasedCablingRequest>, I>>(base?: I): DesignBasedCablingRequest {
    return DesignBasedCablingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DesignBasedCablingRequest>, I>>(object: I): DesignBasedCablingRequest {
    const message = createBaseDesignBasedCablingRequest();
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.design = (object.design !== undefined && object.design !== null)
      ? FabricDesign.fromPartial(object.design)
      : undefined;
    message.dryRun = object.dryRun ?? false;
    message.failFast = object.failFast ?? false;
    message.includeCablingPlan = object.includeCablingPlan ?? false;
    message.nodeData = object.nodeData?.map((e) => DesignNodeData.fromPartial(e)) || [];
    message.includeExceptions = object.includeExceptions ?? false;
    message.candidate = object.candidate ?? "";
    message.excludeObservedStateDataInResponse = object.excludeObservedStateDataInResponse ?? false;
    return message;
  },
};

function createBaseRuleExecutionException(): RuleExecutionException {
  return {
    swGroupRule: undefined,
    svrGroupRule: undefined,
    portDeficit: 0,
    node1Name: "",
    node1Id: "",
    node2Name: "",
    node2Id: "",
    node2RailName: "",
    node2RailId: "",
  };
}

export const RuleExecutionException: MessageFns<RuleExecutionException> = {
  encode(message: RuleExecutionException, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.swGroupRule !== undefined) {
      SwitchGroupConnectivityRule.encode(message.swGroupRule, writer.uint32(10).fork()).join();
    }
    if (message.svrGroupRule !== undefined) {
      ServerGroupConnectivityRule.encode(message.svrGroupRule, writer.uint32(18).fork()).join();
    }
    if (message.portDeficit !== 0) {
      writer.uint32(24).uint32(message.portDeficit);
    }
    if (message.node1Name !== "") {
      writer.uint32(34).string(message.node1Name);
    }
    if (message.node1Id !== "") {
      writer.uint32(42).string(message.node1Id);
    }
    if (message.node2Name !== "") {
      writer.uint32(50).string(message.node2Name);
    }
    if (message.node2Id !== "") {
      writer.uint32(58).string(message.node2Id);
    }
    if (message.node2RailName !== "") {
      writer.uint32(66).string(message.node2RailName);
    }
    if (message.node2RailId !== "") {
      writer.uint32(74).string(message.node2RailId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RuleExecutionException {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRuleExecutionException();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.swGroupRule = SwitchGroupConnectivityRule.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.svrGroupRule = ServerGroupConnectivityRule.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.portDeficit = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.node1Name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.node1Id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.node2Name = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.node2Id = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.node2RailName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.node2RailId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RuleExecutionException {
    return {
      swGroupRule: isSet(object.swGroupRule) ? SwitchGroupConnectivityRule.fromJSON(object.swGroupRule) : undefined,
      svrGroupRule: isSet(object.svrGroupRule) ? ServerGroupConnectivityRule.fromJSON(object.svrGroupRule) : undefined,
      portDeficit: isSet(object.portDeficit) ? globalThis.Number(object.portDeficit) : 0,
      node1Name: isSet(object.node1Name) ? globalThis.String(object.node1Name) : "",
      node1Id: isSet(object.node1Id) ? globalThis.String(object.node1Id) : "",
      node2Name: isSet(object.node2Name) ? globalThis.String(object.node2Name) : "",
      node2Id: isSet(object.node2Id) ? globalThis.String(object.node2Id) : "",
      node2RailName: isSet(object.node2RailName) ? globalThis.String(object.node2RailName) : "",
      node2RailId: isSet(object.node2RailId) ? globalThis.String(object.node2RailId) : "",
    };
  },

  toJSON(message: RuleExecutionException): unknown {
    const obj: any = {};
    if (message.swGroupRule !== undefined) {
      obj.swGroupRule = SwitchGroupConnectivityRule.toJSON(message.swGroupRule);
    }
    if (message.svrGroupRule !== undefined) {
      obj.svrGroupRule = ServerGroupConnectivityRule.toJSON(message.svrGroupRule);
    }
    if (message.portDeficit !== 0) {
      obj.portDeficit = Math.round(message.portDeficit);
    }
    if (message.node1Name !== "") {
      obj.node1Name = message.node1Name;
    }
    if (message.node1Id !== "") {
      obj.node1Id = message.node1Id;
    }
    if (message.node2Name !== "") {
      obj.node2Name = message.node2Name;
    }
    if (message.node2Id !== "") {
      obj.node2Id = message.node2Id;
    }
    if (message.node2RailName !== "") {
      obj.node2RailName = message.node2RailName;
    }
    if (message.node2RailId !== "") {
      obj.node2RailId = message.node2RailId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RuleExecutionException>, I>>(base?: I): RuleExecutionException {
    return RuleExecutionException.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RuleExecutionException>, I>>(object: I): RuleExecutionException {
    const message = createBaseRuleExecutionException();
    message.swGroupRule = (object.swGroupRule !== undefined && object.swGroupRule !== null)
      ? SwitchGroupConnectivityRule.fromPartial(object.swGroupRule)
      : undefined;
    message.svrGroupRule = (object.svrGroupRule !== undefined && object.svrGroupRule !== null)
      ? ServerGroupConnectivityRule.fromPartial(object.svrGroupRule)
      : undefined;
    message.portDeficit = object.portDeficit ?? 0;
    message.node1Name = object.node1Name ?? "";
    message.node1Id = object.node1Id ?? "";
    message.node2Name = object.node2Name ?? "";
    message.node2Id = object.node2Id ?? "";
    message.node2RailName = object.node2RailName ?? "";
    message.node2RailId = object.node2RailId ?? "";
    return message;
  },
};

function createBaseDesignBasedCablingResponse(): DesignBasedCablingResponse {
  return { connections: [], execStatus: 0, exceptions: [], observedConnections: [] };
}

export const DesignBasedCablingResponse: MessageFns<DesignBasedCablingResponse> = {
  encode(message: DesignBasedCablingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.connections) {
      CablingConnection.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.execStatus !== 0) {
      writer.uint32(16).int32(message.execStatus);
    }
    for (const v of message.exceptions) {
      RuleExecutionException.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.observedConnections) {
      CablingConnection.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DesignBasedCablingResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDesignBasedCablingResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.connections.push(CablingConnection.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.execStatus = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.exceptions.push(RuleExecutionException.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.observedConnections.push(CablingConnection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DesignBasedCablingResponse {
    return {
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => CablingConnection.fromJSON(e))
        : [],
      execStatus: isSet(object.execStatus) ? cablingPlanStatusFromJSON(object.execStatus) : 0,
      exceptions: globalThis.Array.isArray(object?.exceptions)
        ? object.exceptions.map((e: any) => RuleExecutionException.fromJSON(e))
        : [],
      observedConnections: globalThis.Array.isArray(object?.observedConnections)
        ? object.observedConnections.map((e: any) => CablingConnection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DesignBasedCablingResponse): unknown {
    const obj: any = {};
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => CablingConnection.toJSON(e));
    }
    if (message.execStatus !== 0) {
      obj.execStatus = cablingPlanStatusToJSON(message.execStatus);
    }
    if (message.exceptions?.length) {
      obj.exceptions = message.exceptions.map((e) => RuleExecutionException.toJSON(e));
    }
    if (message.observedConnections?.length) {
      obj.observedConnections = message.observedConnections.map((e) => CablingConnection.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DesignBasedCablingResponse>, I>>(base?: I): DesignBasedCablingResponse {
    return DesignBasedCablingResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DesignBasedCablingResponse>, I>>(object: I): DesignBasedCablingResponse {
    const message = createBaseDesignBasedCablingResponse();
    message.connections = object.connections?.map((e) => CablingConnection.fromPartial(e)) || [];
    message.execStatus = object.execStatus ?? 0;
    message.exceptions = object.exceptions?.map((e) => RuleExecutionException.fromPartial(e)) || [];
    message.observedConnections = object.observedConnections?.map((e) => CablingConnection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetObservedStateRequest(): GetObservedStateRequest {
  return { fabricId: "", nodeData: [], design: undefined };
}

export const GetObservedStateRequest: MessageFns<GetObservedStateRequest> = {
  encode(message: GetObservedStateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.nodeData) {
      DesignNodeData.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.design !== undefined) {
      FabricDesign.encode(message.design, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetObservedStateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetObservedStateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeData.push(DesignNodeData.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.design = FabricDesign.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetObservedStateRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nodeData: globalThis.Array.isArray(object?.nodeData)
        ? object.nodeData.map((e: any) => DesignNodeData.fromJSON(e))
        : [],
      design: isSet(object.design) ? FabricDesign.fromJSON(object.design) : undefined,
    };
  },

  toJSON(message: GetObservedStateRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nodeData?.length) {
      obj.nodeData = message.nodeData.map((e) => DesignNodeData.toJSON(e));
    }
    if (message.design !== undefined) {
      obj.design = FabricDesign.toJSON(message.design);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetObservedStateRequest>, I>>(base?: I): GetObservedStateRequest {
    return GetObservedStateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetObservedStateRequest>, I>>(object: I): GetObservedStateRequest {
    const message = createBaseGetObservedStateRequest();
    message.fabricId = object.fabricId ?? "";
    message.nodeData = object.nodeData?.map((e) => DesignNodeData.fromPartial(e)) || [];
    message.design = (object.design !== undefined && object.design !== null)
      ? FabricDesign.fromPartial(object.design)
      : undefined;
    return message;
  },
};

function createBaseGetObservedStateResponse(): GetObservedStateResponse {
  return { observedState: [] };
}

export const GetObservedStateResponse: MessageFns<GetObservedStateResponse> = {
  encode(message: GetObservedStateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.observedState) {
      CablingConnection.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetObservedStateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetObservedStateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.observedState.push(CablingConnection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetObservedStateResponse {
    return {
      observedState: globalThis.Array.isArray(object?.observedState)
        ? object.observedState.map((e: any) => CablingConnection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetObservedStateResponse): unknown {
    const obj: any = {};
    if (message.observedState?.length) {
      obj.observedState = message.observedState.map((e) => CablingConnection.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetObservedStateResponse>, I>>(base?: I): GetObservedStateResponse {
    return GetObservedStateResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetObservedStateResponse>, I>>(object: I): GetObservedStateResponse {
    const message = createBaseGetObservedStateResponse();
    message.observedState = object.observedState?.map((e) => CablingConnection.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
